export const CASE_REVIEW_FILTERS = [
  { id: "all", label: "All fields" },
  { id: "high", label: "High" },
  { id: "medium", label: "Medium" },
  { id: "low", label: "Low" },
  { id: "unreviewed", label: "Unreviewed AI" },
  { id: "manual", label: "Needs manual entry" },
  { id: "changed", label: "Unsaved" },
] as const;
export type CaseReviewFilter = typeof CASE_REVIEW_FILTERS[number]["id"];

/** Each filter's own id, so a call site names it instead of retyping the literal. */
export const CASE_REVIEW_FILTER_IDS = Object.fromEntries(
  CASE_REVIEW_FILTERS.map((filter) => [filter.id, filter.id]),
) as Record<CaseReviewFilter, CaseReviewFilter>;

export const CONFIDENCE_FILTERS: readonly CaseReviewFilter[] =
  [CASE_REVIEW_FILTER_IDS.high, CASE_REVIEW_FILTER_IDS.medium, CASE_REVIEW_FILTER_IDS.low];
